// Board colours shared by every chessboard of the app (blue-grey, matching the logo)
export const BOARD_LIGHT_SQUARE = { backgroundColor: '#dfe6eb' };
export const BOARD_DARK_SQUARE = { backgroundColor: '#8aa3b4' };
export const LAST_MOVE_COLOR = 'rgba(250, 214, 60, 0.5)';
export const SELECTED_COLOR = 'rgba(56, 168, 174, 0.55)';
export const MOVE_DOT = 'radial-gradient(circle, rgba(12, 18, 24, 0.28) 19%, transparent 21%)';
export const CAPTURE_RING = 'radial-gradient(circle, transparent 74%, rgba(12, 18, 24, 0.28) 76%)';
export const NOTATION_LIGHT = { color: '#6f8899', fontWeight: 600 };
export const NOTATION_DARK = { color: '#eef2f5', fontWeight: 600 };
